export function setStateToClient() {
  if (this.state.serverOrClient !== "client") {
    this.setState({ serverOrClient: "client" })
  }
}
